import { AutoComplete, ISelectType } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import MainApi from "../../../../../../services/mainApi.service";
import { useTranslation } from "react-i18next";

const TICKET_SERVICE_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketServices/";
const ticketService = new MainApi<ISelectType>(TICKET_SERVICE_ROUTE);

const translationPath = "page.settings.crm.sendLimitMonths.";

export const TicketService = memo(() => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        name="ticketService"
        request={ticketService.list}
        label={t(translationPath + "ticket_service")}
        getOptionLabel={(option) => option.name}
        size="small"
        fullWidth
      />
    </Grid>
  );
});
